module.exports = __webpack_public_path__ + "static/media/satv_m2.d5654972.webp";